module.exports = __webpack_public_path__ + "static/logo-amt-e0b1083e2baa1358e4827a529b5bc228.jpg";